import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { IonicModule } from "ionic-angular";
import { ComplexControlComponent } from "./complex-control.component";
import { FieldWrapperModule } from "../../modules/field-wrapper/field-wrapper.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        TranslateModule.forChild()
    ],
    declarations: [
        ComplexControlComponent
    ],
    exports: [
        ComplexControlComponent
    ]
})
export class ComplexControlModule {

}



// WEBPACK FOOTER //
// ./src/vas/controls/complex/form/complex-control.module.ts